const LOCALE_MAP = {
  es: "es-ES",
  en: "en-US",
};

/**
 * Maps an i18next language code (e.g. "es", "en-US") to the corresponding
 * TalkJS IETF locale tag. Falls back to "en-US" for unknown languages.
 */
export function getTalkJsLocale(language) {
  const base = (language || "en").split("-")[0].toLowerCase();
  return LOCALE_MAP[base] || "en-US";
}
